(function (prototype) {
    if (!prototype.matches)
        prototype.matches = prototype.msMatchesSelector ||
            prototype.webkitMatchesSelector;

    if (!prototype.closest)
        prototype.closest = function (s) {
            var el = this;
            if (!document.documentElement.contains(el)) return null;
            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
})(Element.prototype);

define("SageDotCom/polyfills/closest", function(){});

